import React, { useState } from "react";
import { Grid, Box, Typography } from "@mui/material";
import classes from "../Styles/about.module.css";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FolderIcon from "@mui/icons-material/Folder";
import BallotIcon from "@mui/icons-material/Ballot";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
const PersonalInformation = () => {
  const [isInterestOpen, setIsInterest] = useState(true);
  const [isPersonalOpen, setIsPersonal] = useState(true);
  const [isProfOpen, setIsProf] = useState(false);
  const [isEdOpen, setIsEd] = useState(false);
  const [isContactOpen, setIsContact] = useState(true);
  const [isSkillOpen, setIsSkill] = useState(false);
  const [isExp, setIsExp] = useState(false);
  const [isRefer, setIsRefer] = useState(false);
  const [isHobbies, setIsHob] = useState(false);
  return (
    <>
      <Grid item md={2.4} xs={12} className={classes.grid_item_inner}>
        <Box
          onClick={() => setIsPersonal(!isPersonalOpen)}
          sx={{
            display: "flex",
            color: "white",
            width: "100%",
            borderBottom: "0.25px solid #1E2D3D",
            backgroundColor: { xs: "#1E2D3D", md: "transparent" },
            pt: 2,
            pb: 1,
            cursor: "pointer",
          }}
        >
          {isPersonalOpen ? <ArrowDropDownIcon /> : <ArrowRightIcon />}

          <Typography className={classes.about_text}>
            personal-information
          </Typography>
        </Box>
        <Box sx={{ display: isPersonalOpen ? "block" : "none" }}>
          <Box
            onClick={() => setIsInterest(!isInterestOpen)}
            sx={{
              display: "flex",
              color: "#607B96",
              width: "100%",
              pl: 0.4,
              pt: 2,
              pb: 1,
              cursor: "pointer",
            }}
          >
            {isInterestOpen ? (
              <ArrowForwardIosIcon
                sx={{ fontSize: "15px", pt: 0.3, transform: "rotate(90deg)" }}
              />
            ) : (
              <ArrowForwardIosIcon sx={{ fontSize: "15px", pt: 0.3 }} />
            )}

            <FolderIcon
              sx={{ color: "#43D9AD", pl: 0.5, pr: 1, fontSize: "20px" }}
            />
            <Typography className={classes.about_text_folder}>
              interests
            </Typography>
          </Box>
          <Box sx={{ display: isInterestOpen ? "block" : "none" }}>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                web-3
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                gaming
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                fun
              </Typography>
            </Box>
          </Box>

          <Box
            onClick={() => setIsEd(!isEdOpen)}
            sx={{
              display: "flex",
              color: "#607B96",
              width: "100%",
              pl: 0.4,
              pt: 2,
              pb: 1,
              cursor: "pointer",
            }}
          >
            {isEdOpen ? (
              <ArrowForwardIosIcon
                sx={{ fontSize: "15px", pt: 0.3, transform: "rotate(90deg)" }}
              />
            ) : (
              <ArrowForwardIosIcon sx={{ fontSize: "15px", pt: 0.3 }} />
            )}
            <FolderIcon
              sx={{ color: "#3A49A4", pl: 0.5, pr: 1, fontSize: "20px" }}
            />
            <Typography className={classes.about_text_folder}>
              education
            </Typography>
          </Box>
          <Box sx={{ display: isEdOpen ? "block" : "none" }}>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                babcock-university
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                kings-college-lagos
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                starfield-early-years
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* prof */}
        <Box
          onClick={() => setIsProf(!isProfOpen)}
          sx={{
            display: { xs: "flex", md: "none" },
            color: "white",
            width: "100%",
            borderBottom: "0.25px solid #1E2D3D",
            backgroundColor: "#1E2D3D",
            mt: 0.5,
            mb: 0.5,
            pt: 2,
            pb: 1,
            cursor: "pointer",
          }}
        >
          {isProfOpen ? <ArrowDropDownIcon /> : <ArrowRightIcon />}

          <Typography className={classes.about_text}>
            professional-information
          </Typography>
        </Box>

        <Box sx={{ display: isProfOpen ? "block" : "none" }}>
          <Box
            onClick={() => setIsSkill(!isSkillOpen)}
            sx={{
              display: "flex",
              color: "#607B96",
              width: "100%",
              pl: 0.4,
              pt: 2,
              pb: 1,
              cursor: "pointer",
            }}
          >
            {isSkillOpen ? (
              <ArrowForwardIosIcon
                sx={{ fontSize: "15px", pt: 0.3, transform: "rotate(90deg)" }}
              />
            ) : (
              <ArrowForwardIosIcon sx={{ fontSize: "15px", pt: 0.3 }} />
            )}

            <FolderIcon
              sx={{ color: "#43D9AD", pl: 0.5, pr: 1, fontSize: "20px" }}
            />
            <Typography className={classes.about_text_folder}>skils</Typography>
          </Box>
          <Box sx={{ display: isSkillOpen ? "block" : "none" }}>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                html
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                css
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                js
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                react-js
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                react-query
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                typescript
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                bootstrap
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                mui
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                python-django
              </Typography>
            </Box>
          </Box>

          <Box
            onClick={() => setIsExp(!isExp)}
            sx={{
              display: "flex",
              color: "#607B96",
              width: "100%",
              pl: 0.4,
              pt: 2,
              pb: 1,
              cursor: "pointer",
            }}
          >
            {isExp ? (
              <ArrowForwardIosIcon
                sx={{ fontSize: "15px", pt: 0.3, transform: "rotate(90deg)" }}
              />
            ) : (
              <ArrowForwardIosIcon sx={{ fontSize: "15px", pt: 0.3 }} />
            )}
            <FolderIcon
              sx={{ color: "#3A49A4", pl: 0.5, pr: 1, fontSize: "20px" }}
            />
            <Typography className={classes.about_text_folder}>
              experience
            </Typography>
          </Box>
          <Box sx={{ display: isExp ? "block" : "none" }}>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                prunedge (jan 2022-jun 2022)
              </Typography>
            </Box>
          </Box>

          <Box
            onClick={() => setIsRefer(!isRefer)}
            sx={{
              display: "flex",
              color: "#607B96",
              width: "100%",
              pl: 0.4,
              pt: 2,
              pb: 1,
              cursor: "pointer",
            }}
          >
            {isRefer ? (
              <ArrowForwardIosIcon
                sx={{ fontSize: "15px", pt: 0.3, transform: "rotate(90deg)" }}
              />
            ) : (
              <ArrowForwardIosIcon sx={{ fontSize: "15px", pt: 0.3 }} />
            )}
            <FolderIcon
              sx={{ color: "#E99287", pl: 0.5, pr: 1, fontSize: "20px" }}
            />
            <Typography className={classes.about_text_folder}>
              referees
            </Typography>
          </Box>
          <Box sx={{ display: isRefer ? "block" : "none" }}>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                olaniyan-olalekan (+15195051795)
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                oluleke-okewale (08131058926)
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                bankole-odulesi (07039600122)
              </Typography>
            </Box>
          </Box>
        </Box>

        {/*end prof */}

        <Box
          onClick={() => setIsHob(!isHobbies)}
          sx={{
            display: { xs: "flex", md: "none" },
            color: "white",
            width: "100%",
            borderBottom: "0.25px solid #1E2D3D",
            backgroundColor: "#1E2D3D",
            mt: 0.5,
            mb: 0.5,
            pt: 2,
            pb: 1,
            cursor: "pointer",
          }}
        >
          {isHobbies ? <ArrowDropDownIcon /> : <ArrowRightIcon />}

          <Typography className={classes.about_text}>hobbies</Typography>
        </Box>
        <Box sx={{ display: isHobbies ? "block" : "none" }}>
          <Box
            sx={{
              display: "flex",
              color: "#607B96",
              width: "100%",
              pl: 0.4,
              pt: 2,
              pb: 1,
            }}
          >
            <BallotIcon
              sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
            />
            <Typography className={classes.about_text_folder_under}>
              Learning
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              color: "#607B96",
              width: "100%",
              pl: 0.4,
              pt: 2,
              pb: 1,
            }}
          >
            <BallotIcon
              sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
            />
            <Typography className={classes.about_text_folder_under}>
              Reading
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              color: "#607B96",
              width: "100%",
              pl: 0.4,
              pt: 2,
              pb: 1,
            }}
          >
            <BallotIcon
              sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
            />
            <Typography className={classes.about_text_folder_under}>
              Coding
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              color: "#607B96",
              width: "100%",
              pl: 0.4,
              pt: 2,
              pb: 1,
            }}
          >
            <BallotIcon
              sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
            />
            <Typography className={classes.about_text_folder_under}>
              Tutoring
            </Typography>
          </Box>
        </Box>
        <Box
          onClick={() => setIsContact(!isContactOpen)}
          sx={{
            display: "flex",
            color: "white",
            width: "100%",
            borderTop: "0.25px solid #1E2D3D",
            borderBottom: "0.25px solid #1E2D3D",
            backgroundColor: { xs: "#1E2D3D", md: "transparent" },
            pt: 2,
            pb: 1,
            cursor: "pointer",
          }}
        >
          {isContactOpen ? <ArrowDropDownIcon /> : <ArrowRightIcon />}

          <Typography className={classes.about_text}>contacts</Typography>
        </Box>
        <Box sx={{ display: isContactOpen ? "block" : "none" }}>
          <Box
            sx={{
              display: "flex",
              color: "white",
              width: "100%",

              pt: 2,
              pb: 1,
            }}
          >
            <EmailIcon
              sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
            />
            <Typography
              className={classes.about_text_folder_under}
              sx={{ wordBreak: "break-word" }}
            >
              oyelolaboye@gmail.com
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              color: "white",
              width: "100%",

              pt: 2,
              pb: 1,
            }}
          >
            <PhoneIcon
              sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
            />
            <Typography className={classes.about_text_folder_under}>
              289-880-5234
            </Typography>
          </Box>
        </Box>
      </Grid>
    </>
  );
};

export default PersonalInformation;
